@if (!authService.isAuthReady()) {
  <div class="flex h-screen items-center justify-center bg-brand-bg">
    <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-primary"></div>
  </div>
} @else {
  <div class="flex h-screen bg-brand-bg text-gray-900 dark:text-slate-100 overflow-hidden font-sans">
    @if (authService.currentUser()) {
      <app-sidebar></app-sidebar>
    }
    <div class="flex-1 flex flex-col h-full overflow-hidden relative">
      @if (authService.currentUser()) {
        <app-header></app-header>
      }
      <main class="flex-1 overflow-y-auto relative flex flex-col">
        <div class="flex-1 flex flex-col">
          <router-outlet></router-outlet>
        </div>
        @if (authService.currentUser()) {
          <app-footer></app-footer>
        }
      </main>
    </div>
  </div>
}

@if (!isProduction) {
  <div class="fixed bottom-3 right-3 z-[9999] flex items-center gap-1.5 rounded-full bg-amber-400/60 px-3 py-1 text-xs font-bold text-amber-900/80 shadow select-none backdrop-blur-sm">
    <span class="material-symbols-outlined text-[14px]">bug_report</span>
    MODO TESTE
  </div>
}
